import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from "@mui/material";
import Header from "../../../../common/Header";
import Footer from "../../../../common/Footer";
import { apiList, invokeApi } from "../../../../services/apiServices";
import { config } from "../../../../config/config";

const ArticlesCategory = () => {
    const { category } = useParams(); // This is the slug (e.g., "marine-life")
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [displayCategoryName, setDisplayCategoryName] = useState("");

    const normalize = (str) => str?.toLowerCase().replace(/\s+/g, '-') || "";

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const response = await invokeApi(config.getMyCollege + apiList.getArticles, {});
                if (response?.status === 200 && response?.data?.articles) {
                    const filtered = response.data.articles.filter(
                        article => normalize(article.categoryName || article.category || article.category_name || article.title) === category
                    );
                    setArticles(filtered);
                    if (filtered.length > 0) {
                        // Use the first match to get the pretty display name
                        setDisplayCategoryName(filtered[0].categoryName || filtered[0].category || filtered[0].category_name || filtered[0].title);
                    } else {
                        // Fallback to capitalizing slug if no matches found immediately (or empty)
                        setDisplayCategoryName(category.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()));
                    }
                }
            } catch (error) {
                console.error("Error fetching articles:", error);
            } finally {
                setLoading(false);
            }
        };

        if (category) {
            fetchArticles();
        }
    }, [category]);

    return (
        <>
            <Header />
            <Box sx={{ minHeight: "60vh", py: 5, backgroundColor: "#f9f9f9" }}>
                <Container maxWidth="lg">
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        sx={{
                            color: "#005555",
                            fontWeight: 400,
                            mb: 5,
                            mt: 5
                        }}
                    >
                        {displayCategoryName}
                    </Typography>

                    <Box sx={{ width: "60px", height: "4px", backgroundColor: "#d3d3d3", mx: "auto", mb: 6 }} />

                    {loading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
                            <CircularProgress />
                        </Box>
                    ) : articles.length > 0 ? (
                        <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: 0 }}>
                            <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: "bold", color: "#333", width: "100px", borderRight: "1px solid #e0e0e0", borderBottom: "1px solid #e0e0e0", padding: "16px" }}>Year</TableCell>
                                        <TableCell sx={{ fontWeight: "bold", color: "#333", borderBottom: "1px solid #e0e0e0", padding: "16px" }}>Citation</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {articles.map((item) => (
                                        <TableRow key={item.id}>
                                            <TableCell component="th" scope="row" sx={{ color: "#333", borderRight: "1px solid #e0e0e0", borderBottom: "1px solid #e0e0e0", padding: "16px" }}>
                                                {item.year}
                                            </TableCell>
                                            <TableCell sx={{ color: "#333", fontSize: "1rem", lineHeight: 1.6, borderBottom: "1px solid #e0e0e0", padding: "16px", "& a": { color: "#00796b", textDecoration: "underline" } }}>
                                                <div dangerouslySetInnerHTML={{ __html: item.content }} />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography align="center" variant="h6" color="textSecondary">
                            No articles found in this category.
                        </Typography>
                    )}
                </Container>
            </Box>
            <Footer variant="light" />
        </>
    );
};

export default ArticlesCategory;
